/**
 * Container for LoanSearch form
 *
 * @prettier
 * @author Alexander Nagelberg
 */
import React from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'

import LoanSearch from '../components/LoanSearch'

import { fetchRemittance } from '../actions/lenderActions'
import { fullGearURL, GEAR_URLs } from '../actions/lenderConfig'

/**
 *
 * @param {Object} props
 * @param {Boolean} [props.hardLink] causes app reload necessary to switch between v1/v2
 */
const LoanSearchContainer = ({ fetchRemittance, hardLink }) => {
  const history = useHistory()

  return (
    <LoanSearch
      form='lender-search'
      hardLink={hardLink}
      onSubmit={({ lin }) =>
        fetchRemittance(lin, {
          useWindow: hardLink,
          history: hardLink ? null : history,
          baseUrl: fullGearURL(GEAR_URLs.REMITTANCE_WIZARD_PATH, null, { lin })
        })
      }
    />
  )
}

export default connect(null, { fetchRemittance })(LoanSearchContainer)
